export default __webpack_public_path__ + "static/media/redo.e6fdb837.svg";